import React, { memo } from 'react';
import { Row, Col } from 'react-bootstrap';
import Icon from '@components/@core/Icon';

const EmptyList = () => (
    <div className="career-required-instances">
        <div className="placeholder">
            <Row className="mx-0">
                <Col xs={10} className="d-flex ai-center jc-between px-0">
                    <div className="d-flex ai-center w-100">
                        <Icon name="far fa-circle me-3" size={25} color="#f0f0f0" />
                        <div className="w-100">
                            <div className="empty long mb-1" />
                            <div className="empty medium" />
                        </div>
                    </div>
                    <div>
                        <div className="empty circle" />
                        <div className="empty small" />
                    </div>
                </Col>
                <Col xs={2} className="d-flex ai-center px-0">
                    <div className="empty square" />
                </Col>
            </Row>
        </div>
    </div>
);

export default memo(EmptyList);
